var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-success-container",class:{
  isMobile: _vm.isMobile()
}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sys-max-width"},[_c('div',{staticClass:"registry-success"},[_c('div',{staticClass:"icon mx-auto"}),_c('div',{staticClass:"text"},[_vm._v("问卷提交成功")])])])
}]

export { render, staticRenderFns }